export const SelectActionTypes = {
  buttonClick: 'buttonClick',
  browserAutoFill: 'browserAutoFill'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/useSelect/useSelect.types.js
// module id = 685
// module chunks = 0